import React, { useEffect } from "react";
import { FormProvider } from "react-hook-form";
import SelfExclusionClient from "@common/api/SelfExclusionClient";
import useEventDetailsGrid from "@hooks/useEventDetailsGrid";
import ComplianceHeader from "../ComplianceHeader";
import useComplianceView from "../../../hooks/useComplianceView";
import { handleError } from "@common/components/helpers/error";
import useSelfExclusion from "@common/components/hooks/useSelfExclusion";
import LoginAction from "@common/redux/actions/LoginAction";
import SelfExclusionForm from "@common/components/shared/SelfExclusion/SelfExclusionForm";
import { parseSelfExclusionResponse } from "../../../common/components/helpers/compliance.js";

function useSelfExclusionContainer() {
  const { setViewData } = useComplianceView();
  const {
    activeRow: {
      event: { id },
    },
  } = useEventDetailsGrid();
  const { methods } = useSelfExclusion();
  const { reset, getValues } = methods;

  const loadRecord = (isRead = true) => {
    if (!id) {
      return;
    }
    setViewData({ formLoading: true });

    const fnRead = isRead
      ? SelfExclusionClient.Read
      : SelfExclusionClient.ReadForUpdate;

    fnRead(id).then(
      (response) => {
        const {
          record: {
            site: { guid },
          },
        } = response;
        LoginAction.dispatch({ siteGuid: guid, isInReadMode: isRead });
        const parsed = parseSelfExclusionResponse(response);
        reset({
          ...getValues(),
          ...parsed,
        });
      },
      (error) => {
        setViewData({ formLoading: false });
        handleError(error);
      },
    );
  };

  useEffect(loadRecord, [id]);

  return {
    methods,
    loadRecord,
  };
}

const SelfExclusionContainer = () => {
  const { methods, loadRecord } = useSelfExclusionContainer();

  return (
    <FormProvider {...methods}>
      <ComplianceHeader title="Self Exclusion" loadRecord={loadRecord} />
      <SelfExclusionForm />
    </FormProvider>
  );
};

export default SelfExclusionContainer;
